/*eslint-disable*/
import { SwatchLegendItem } from 'mapcontrols/components/subComponents';
import { LOCATION_LIST } from 'mapcontrols/constants';
import React from 'react';
import { BaseSelect, Picker } from 'ui-kit';
import * as Styled from './styles';

const InspectionFailure = ({ stateForm, handleStateForm, type = '' }) => {
  return (
    <Styled.DatePanelWrapper>
      <Styled.SubPanelLabel>Rate by</Styled.SubPanelLabel>
      <BaseSelect
        name={`${type}-locations`}
        labelText=""
        options={LOCATION_LIST}
        value={stateForm[type].value}
        onChange={(selectedValue) => handleStateForm({ value: selectedValue, type, dateType: 'value' })}
        inputId={`${type}-locations`}
      />
      <Styled.SubPanelLabel>Within time period</Styled.SubPanelLabel>
      <Styled.PickerWrapper>
        <span>from</span>
        <Picker
          showMonthYearDropdown
          idInput={`startDate-${type}`}
          onChange={(value) => handleStateForm({ value, type, dateType: 'startDate' })}
          selected={stateForm[type].startDate || null}
          inputFor={`startDate-${type}`}
          name={`startDate-${type}`}
          menuPlacement="top"
          required
        />
        <span>to</span>
        <Picker
          showMonthYearDropdown
          idInput={`endDate-${type}`}
          onChange={(value) => handleStateForm({ value, type, dateType: 'endDate' })}
          selected={stateForm[type].endDate || null}
          inputFor={`endDate-${type}`}
          name={`endDate-${type}`}
          menuPlacement="top"
          required
        />
      </Styled.PickerWrapper>
      <>
        <Styled.SwatchLegendSection>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem backgroundColor="red" borderColor="#000000" type="square" />
            <span>Over 40%</span>
          </Styled.SwatchLegendWrapper>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem backgroundColor="orange" borderColor="#000000" type="square" />
            <span>30% - 39%</span>
          </Styled.SwatchLegendWrapper>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem backgroundColor="lemonChiffon" borderColor="#000000" type="square" />
            <span>20% - 29%</span>
          </Styled.SwatchLegendWrapper>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem backgroundColor="lightBlue" borderColor="#000000" type="square" />
            <span>10% - 19%</span>
          </Styled.SwatchLegendWrapper>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem backgroundColor="dodgerBlue" borderColor="#000000" type="square" />
            <span>Under 10%</span>
          </Styled.SwatchLegendWrapper>
          <Styled.SwatchLegendWrapper>
            <SwatchLegendItem
              style={{
                backgroundImage: `
    linear-gradient(45deg, #ccc 25%, transparent 25%),
    linear-gradient(-45deg, #ccc 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #ccc 75%),
    linear-gradient(-45deg, transparent 75%, #ccc 75%),
    linear-gradient(45deg, #eee 25%, transparent 25%),
    linear-gradient(-45deg, #eee 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, #eee 75%),
    linear-gradient(-45deg, transparent 75%, #eee 75%)
  `,
                backgroundSize: '6px 6px',
                backgroundPosition: '0 0, 0 3px, 3px -3px, -3px 0px, 1px 1px, 1px 4px, 4px -2px, -2px 1px',
              }}
              type="square"
            />
            <span>No Inspection</span>
          </Styled.SwatchLegendWrapper>
        </Styled.SwatchLegendSection>
      </>
    </Styled.DatePanelWrapper>
  );
};

export default InspectionFailure;
